// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1AAfI","dragIcon":"Choice_dragIcon__1QJtb","left":"Choice_left__EQ4Vk","input":"Choice_input__3jgRM"};